import memoizeResult from '../../memoize-result.js'

const geometriesAsArray = memoizeResult(state => Object.values(state.geometries))

/*
 * Return geometry for the given Collaboration
 * @sig geometryForCollaboration :: (State, Collaboration) -> Geometry
 */
const geometryForCollaboration = (state, collaboration) => state.geometries[collaboration.geometryId]

// ---------------------------------------------------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------------------------------------------------

const GeometrySelectors = {
    geometriesAsArray,
    geometryForCollaboration,
}

export default GeometrySelectors
